import React from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { AI_COLORS } from '../aiAnalyticsConstants';

export default function SqlQueryAccordion({ sql }) {
  function handleCopySql() {
    if (sql && navigator?.clipboard) {
      navigator.clipboard.writeText(sql).catch(() => {});
    }
  }

  return (
    <Accordion sx={{ mb: 1 }} defaultExpanded={false}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', pr: 1 }}>
          <Typography variant="subtitle2">Query</Typography>
          <Button
            size="small"
            startIcon={<ContentCopyIcon fontSize="small" />}
            onClick={e => {
              e.stopPropagation();
              handleCopySql();
            }}
            sx={{ textTransform: 'none', color: AI_COLORS.primary }}
          >
            Copy
          </Button>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box
          component="pre"
          sx={{
            backgroundColor: AI_COLORS.codeSurface,
            color: AI_COLORS.codeText,
            p: 1.5,
            borderRadius: 1,
            overflow: 'auto',
            fontSize: '0.85rem',
            m: 0
          }}
        >
          {sql}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}
